import { CwjTaskEngineError } from "./types.js";
export class MemoryCwjTaskStore {
    constructor() {
        this.tasks = new Map();
    }
    async load(taskId) {
        return this.tasks.get(taskId);
    }
    async save(task, expectedVersion) {
        const existing = this.tasks.get(task.taskId);
        if (existing) {
            if (existing.version !== expectedVersion) {
                throw new CwjTaskEngineError(`concurrency: expected version ${expectedVersion}, found ${existing.version}`, "concurrency");
            }
        }
        else if (expectedVersion !== 0) {
            throw new CwjTaskEngineError(`concurrency: expected version ${expectedVersion}, but task ${task.taskId} does not exist`, "concurrency");
        }
        this.tasks.set(task.taskId, task);
    }
    async list(filters) {
        let results = Array.from(this.tasks.values());
        if (!filters)
            return results;
        if (filters.projectId !== undefined) {
            results = results.filter((t) => t.context.projectId === filters.projectId);
        }
        if (filters.skillId !== undefined) {
            results = results.filter((t) => t.context.skillId === filters.skillId);
        }
        if (filters.tenantId !== undefined) {
            results = results.filter((t) => t.context.tenantId === filters.tenantId);
        }
        if (filters.ownerId !== undefined) {
            results = results.filter((t) => t.context.ownerId === filters.ownerId);
        }
        if (filters.status !== undefined) {
            results = results.filter((t) => t.status === filters.status);
        }
        if (filters.requestedBy !== undefined) {
            results = results.filter((t) => t.context.requestedBy === filters.requestedBy);
        }
        return results;
    }
    clear() {
        this.tasks.clear();
    }
}
//# sourceMappingURL=memoryTaskStore.js.map